<template>
  <footer>
    <div class="wrapper">
      <!--div class="bottom-img"></div-->
      <div class="nav-bottom">
        <div class="vendor">
          <img src="@/assets/img/pragmatic.png" alt="">
          <img src="@/assets/img/ag.png" alt="">
          <img src="@/assets/img/micro.png" alt="">
          <img src="@/assets/img/habanero.png" alt="">
          <img src="@/assets/img/ori.png" alt="">
          <img src="@/assets/img/big.png" alt="">
          <img src="@/assets/img/pgsoft.png" alt="">
          <img src="@/assets/img/wm.png" alt="">
          <img src="@/assets/img/dream.png" alt="">
          <img src="@/assets/img/betradar.png" alt="">
          <img src="@/assets/img/allbet.png" alt="">
        </div>
        <div class="footerInfo">
          <div class="footerl">
            <a class="flogo" @click="goPageByName('main')">
              <img src="@/assets/img/mega-logo.png" alt="MEGA" />
              <span class="copyright">
                Copyright 2026 MEGA. All Rights Reserved.</span>
            </a>
          </div>
          <div class="footerc">
            <ul class="sns" v-if="siteOption">
              <li @click="siteOption['sns2Link']">
                <img src="@/assets/img/tele.svg" />
                <span>{{siteOption['sns2']}}<em>{{siteOption['sns2Id']}}</em></span>
              </li>
              <li @click="siteOption['sns1Link']">
                <img src="@/assets/img/kakao.svg" />
                <span>{{siteOption['sns1']}}<em>{{siteOption['sns1Id']}}</em></span>
              </li>
              <li v-if="siteOption['sns3']" @click="siteOption['sns3Link']">
                <img src="@/assets/img/zalo.svg" />
                <span>{{siteOption['sns3']}}<em>{{siteOption['sns3Id']}}</em></span>
              </li>
            </ul>
          </div>
          <div class="footerr">
            <ul class="footerNav">
              <li @click="goPageByName('qnaWrite')">{{ $t('front.common.qna')}}</li>
              <li @click="goPageByName('notice')">{{ $t('front.common.notice')}}</li>
              <li @click="goPageByName('faq')">{{ $t('front.common.faq')}}</li>
              <!-- <li @click="goPageByName('bettingGuide')">{{ $t('front.common.bettingGuide')}}</li> -->
              <!-- <li @click="goPageByName('result')">{{ $t('front.common.gameResult')}}</li> -->
              <!-- <li @click="goPageByName('boardList')">{{ $t('front.common.board')}}</li> -->
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="mobiledf dlink">
      <a @click="goPageByName('bettingList')"><i class="fi fi-ss-shield-trust"></i><p>베팅내역</p></a>
      <a @click="goPageByName('notice')"><i class="fi fi-sr-exclamation"></i><p>공지사항</p></a>
      <a @click="goPageByName('main')"><i class="fi fi-sr-house-chimney"></i><p>메인</p></a>
      <a @click="goPageByName('qnaList')"><i class="fi fi-ss-circle-microphone"></i><p>고객센터</p></a>
      <a @click="goPageByName('mypage')"><i class="fi fi-sr-member-list"></i><p>마이페이지</p></a>
    </div>
  </footer>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Footer',
  computed: {
    ...mapState([
      'siteOption'
    ])
  }
}
</script>
<style scoped src="@/styles/footer.css"></style>
<style scoped src="@/styles/common.css"></style>
